document.addEventListener(
  'click',
  (event) => {
    const quotifyButton = event.target.closest(
      '[data-quotify][data-product-id][data-product]'
    );

    if (!quotifyButton) {
      return;
    }

    quotifyButton.removeAttribute('data-product-id');
  },
  { capture: true }
);
